import { isArrayEquals } from "../utils/arrayUtils";

export function isEqual(a: any, b: any) {
  if (Array.isArray(a) && Array.isArray(b)) {
    return isArrayEquals(a, b);
  }
  return a === b;
}
